import { render, staticRenderFns } from "./partyCompany.vue?vue&type=template&id=23152350&scoped=true"
import script from "./partyCompany.vue?vue&type=script&lang=js"
export * from "./partyCompany.vue?vue&type=script&lang=js"
import style0 from "./partyCompany.vue?vue&type=style&index=0&id=23152350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23152350",
  null
  
)

export default component.exports